module.exports = __webpack_public_path__ + "img/Econthon.bf1159de.png";